import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import Bundle from '@saucelabs/sl-component-bundle';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';

import extendedDebuggingReducer from './reducers';
import PerformanceMainContainer from './containers/PerformanceMainContainer';

const performanceReport = () => import(/* webpackChunkName: "performance-report" */ './containers/PerformanceReportContainer');
const performanceHistory = () => import(/* webpackChunkName: "performance-history" */ './containers/PerformanceHistoryContainer');

const PerformanceRoutes = ({ match }) => (
  <SentryBoundary owner={sentryConstants.TEAMS.PERFORMANCE}>
    <Switch>
      <Route
        exact
        path={`${match.url}/:jobId/:pageIndex/history`}
        render={(props) => (
          <PerformanceMainContainer>
            <Bundle load={performanceHistory}>
              {(Component) => <Component {...props} />}
            </Bundle>
          </PerformanceMainContainer>
        )}
      />
      <Route
        exact
        path={`${match.url}/:jobId/:pageIndex`}
        render={(props) => (
          <PerformanceMainContainer>
            <Bundle load={performanceReport}>
              {(Component) => <Component {...props} />}
            </Bundle>
          </PerformanceMainContainer>
        )}
      />
    </Switch>
  </SentryBoundary>
);

PerformanceRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.extendedDebugging', attachReducer(extendedDebuggingReducer),
)(PerformanceRoutes);
export { PerformanceRoutes };
